import http from "./http";
export function fileApi() {
    const path = "/javaApi/front/file";

    return {
        // 获取文件列表
        getFilePath: (params) => {
            return http({
                url: path + '/getFilePath',
                method: 'get',
                params,
            });
        },
        // 获取文件流
        getFileStream: (params) => {
            return http({
                url: path + '/getFileStream/',
                method: 'get',
                params,
            });
        },
        // 上传文件
        upload: (params) => {
            return http({
                url: path + '/upload/',
                method: 'post',
                data: params,
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        },

           // 删除文件
           delete: (id) => {
            return http({
                url: path + '/delete/',
                method: 'post',
                data: {id:id},
            });
        }
    };
}
